import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import LogoSmall from '../../assets/icons/logo.svg';
import LogoFull from '../../assets/icons/logo-full.svg';
export var LOGO_SIZE;
(function (LOGO_SIZE) {
    LOGO_SIZE[LOGO_SIZE["SMALL"] = 0] = "SMALL";
    LOGO_SIZE[LOGO_SIZE["FULL"] = 1] = "FULL";
})(LOGO_SIZE || (LOGO_SIZE = {}));
const Logo = ({ size }) => {
    return (_jsx("div", { className: `logo logo--${size === LOGO_SIZE.SMALL ? 'small' : 'full'}-size`, children: size === LOGO_SIZE.SMALL ? _jsx(LogoSmall, {}) : _jsx(LogoFull, {}) }));
};
export default Logo;
